import React from 'react';
import { Collapse } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import PriceHistory from './PriceHistory/PriceHistory';
import styles from './PriceHistoryView.module.less';

const iconPlus: IconProp = ['fal', 'plus'];
const iconMinus: IconProp = ['fal', 'minus'];

type PriceHistoryViewProps = {
  ownerName: string;
  sourceOwnerId: string;
  sourceProductId: string;
};

const PriceHistoryView: React.FC<PriceHistoryViewProps> = ({ ownerName, sourceOwnerId, sourceProductId }) => {
  const { user } = useAppStateContext();
  if (!user?.appPermissions['enable_price_history']) {
    return null;
  }

  return (
    <Collapse
      bordered={false}
      expandIconPosition={'right'}
      className={styles.collapsedContainer}
      expandIcon={({ isActive }) => <FontAwesomeIcon size={'lg'} icon={isActive ? iconMinus : iconPlus} />}
      defaultActiveKey={['1']}
    >
      <Collapse.Panel header={<h2>Price History</h2>} key="1" className={styles.panel}>
        <PriceHistory ownerName={ownerName} sourceOwnerId={sourceOwnerId} sourceProductId={sourceProductId} />
      </Collapse.Panel>
    </Collapse>
  );
};

export default PriceHistoryView;
